import React from "react"
import { useTranslation } from "react-i18next"

import { ConfirmationOverlay } from "shared/ui/confirmation-overlay/ConfirmationOverlay"

interface LogoutOverlayViewProps {
  autoFocus?: boolean
  logout: () => void
  onCancel: () => void
}

export const LogoutOverlayView = React.memo(
  ({ autoFocus, logout, onCancel }: LogoutOverlayViewProps) => {
    const { t } = useTranslation()

    return (
      <ConfirmationOverlay.Root
        id="confirm-logout-overlay"
        isDanger
        autoFocus={autoFocus}
      >
        <ConfirmationOverlay.Header>
          <ConfirmationOverlay.Title>
            {t("Authentication.SignOut")}
          </ConfirmationOverlay.Title>
        </ConfirmationOverlay.Header>
        <ConfirmationOverlay.Message>
          {t("General.AreYouSure")}
        </ConfirmationOverlay.Message>
        <ConfirmationOverlay.Actions>
          <ConfirmationOverlay.Cancel onClick={onCancel} />
          <ConfirmationOverlay.Submit onClick={logout}>
            {t("Authentication.SignOut")}
          </ConfirmationOverlay.Submit>
        </ConfirmationOverlay.Actions>
      </ConfirmationOverlay.Root>
    )
  }
)
